module.exports = __webpack_public_path__ + "img/1-f.1b5f4769.svg";